import {
  DatagridConfigurable,
  DateInput,
  FunctionField,
  List,
  SelectColumnsButton,
  SelectInput,
  TextField,
  TextInput,
  TopToolbar,
  type RaRecord,
} from "react-admin";
import { ExportButton } from "@/components/ExportButton";
import { DisplayDateField } from "@/components/DisplayDateField";
import { RecipientStatusChip } from "@/components/whatsapp/StatusChips";
import CustomEmpty from "@/components/custom-empty";
import {
  getOutboundMessageFilterFields,
  type OutboundMessageFilterChoice,
} from "./whatsapp-outbound-message-list-filters";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <ExportButton />
  </TopToolbar>
);

function buildFilters() {
  return getOutboundMessageFilterFields().map((field) => {
    if (field.kind === "select") {
      return (
        <SelectInput
          key={field.source}
          source={field.source}
          label={field.label}
          choices={[...(field.choices ?? [])] as OutboundMessageFilterChoice[]}
          alwaysOn={field.alwaysOn}
        />
      );
    }
    if (field.kind === "date") {
      return (
        <DateInput
          key={field.source}
          source={field.source}
          label={field.label}
          alwaysOn={field.alwaysOn}
        />
      );
    }
    return (
      <TextInput
        key={field.source}
        source={field.source}
        label={field.label}
        alwaysOn={field.alwaysOn}
        resettable
      />
    );
  });
}

const outboundMessageFilters = buildFilters();

export default function WhatsappOutboundMessageList() {
  return (
    <List
      actions={<ListActions />}
      filters={outboundMessageFilters}
      sort={{ field: "createdAt", order: "DESC" }}
      empty={
        <CustomEmpty
          title="No outbound messages"
          subtitle="Cron and action template sends will appear here within the retention window"
        />
      }
    >
      <DatagridConfigurable bulkActionButtons={false} rowClick={false}>
        <TextField source="phone" label="Phone" />
        <TextField source="templateName" label="Template" />
        <TextField source="purpose" label="Purpose" />
        <FunctionField
          label="Status"
          sortBy="status"
          render={(record: RaRecord) => (
            <RecipientStatusChip status={record?.status as string | undefined} />
          )}
        />
        <DisplayDateField source="sentAt" label="Sent" showTime sortBy="sentAt" />
        <DisplayDateField source="deliveredAt" label="Delivered" showTime sortBy="deliveredAt" />
        <DisplayDateField source="readAt" label="Read" showTime sortBy="readAt" />
        <TextField source="errorMessage" label="Error" />
        <TextField source="cronName" label="Cron" />
        <DisplayDateField source="createdAt" label="Created" showTime sortBy="createdAt" />
      </DatagridConfigurable>
    </List>
  );
}
